module.exports = __webpack_public_path__ + "static/media/ionela_stan.9dc9c105.jpg";